const keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL || 'https://keycloak.steffen-tietz.de';
const keycloakRealm = process.env.REACT_APP_KEYCLOAK_REALM || 'visus';
const keycloakClientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'report-dashboard';

function getRedirectUri() {
  if (process.env.REACT_APP_REDIRECT_URI) {
    return process.env.REACT_APP_REDIRECT_URI;
  }
  return `${window.location.origin}/callback`;
}

// Clean up stale callback URLs before OIDC initializes
if (typeof window !== 'undefined' && window.location.pathname.includes('/callback')) {
  const params = new URLSearchParams(window.location.search);
  if (params.has('error')) {
    window.history.replaceState({}, document.title, '/');
  }
}

export const oidcConfig = {
  authority: `${keycloakUrl}/realms/${keycloakRealm}`,
  client_id: keycloakClientId,
  redirect_uri: typeof window !== 'undefined' ? getRedirectUri() : '',
  post_logout_redirect_uri: typeof window !== 'undefined' ? window.location.origin : '',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  loadUserInfo: true,
  staleStateAgeInSeconds: 300,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, '/');
  },
};

export const KEYCLOAK_ACCOUNT_URL = `${keycloakUrl}/realms/${keycloakRealm}/account`;
export const KEYCLOAK_ADMIN_URL = keycloakUrl;
